let mem = {}

const memGet = function (type, props) {
  const {_id, name} = props
  if (_id || name) {
    if (_id) {
      return mem[type].ids[_id]
    } else {
      let id = mem[type].names[name]
      return mem[type].ids[id]
    }
  }
}

const memPut = function (type, file) {
  const {_id, name} = file
  if (file.serialize) file = file.serialize()
  mem[type] = mem[type] || {names: {}, ids: {}}
  mem[type].ids[_id] = file
  mem[type].names[name] = _id
  return file
}

const memToArray = function (type) {
  try {
    let res = []
    for (const id in mem[type].ids) {
      res.push(mem[type].ids[id])
    }
    return res
  } catch (e) {
    // console.log('Error on memToArray with type %s', type, e)
    return []
  }
}

const memToFlatArray = function (type) {
  return memToArray(type).map((elm) => ({_id: elm._id, name: elm.name}))
}

const memKill = function (type, props) {
  const {_id, name} = props
  if (_id || name) {
    if (_id) {
      delete mem[type].ids[_id]
      for (let refName in mem[type].names) {
        if (mem[type].names[refName] === _id) {
          delete mem[type].names[refName]
          break
        }
      }
    } else {
      let tId = mem[type].names[name]
      delete mem[type].ids[tId]
      delete mem[type].names[name]
    }
  }
}

const memPurge = function () {
  mem = {}
}

const memDump = function () {
  return mem
}

const memSerialize = function () {
  let string = JSON.stringify(mem)
  // string = string.replace(/\\\\/g, '/')
  // string = string.replace(/'/g, "\\'")
  return string
}

const memLoad = function (type, data) {
  mem = data
}

const memWhere = function (type, props) {
  let allIds = mem[type].ids
  let allFiles = []
  for (const id of Object.keys(allIds)) {
    const file = allIds[id]
    let shouldAdd = true
    for (const prop of Object.keys(props)) {
      if (file[prop]) {
        if (file[prop] !== props[prop]) {
          shouldAdd = false
          break
        }
      }
    }
    if (shouldAdd) {
      allFiles.push(file)
    }
  }
  return allFiles
}

const memParse = function (type, data) {
  if (typeof data === 'string') {
    window.data = data
    mem = JSON.parse(data)
    // let string = data.replace(/\r?\n|\r/g, '')
    // if (typeof window !== 'undefined') {
    //   window.data = data
    // }
    // mem = JSON.parse(string)
  }
}

export const memProps = {
  get: memGet,
  put: memPut,
  kill: memKill,
  toFlatArray: memToFlatArray,
  toArray: memToArray,
  where: memWhere,
  serialize: memSerialize,
  parse: memParse,
  dump: memDump,
  load: memLoad,
  purge: memPurge,
}
